export default __webpack_public_path__ + "static/media/monkey17.a0b29116.jpeg";